export const isLocalEnvironment = () =>{
    const hostName = window.location.hostname;
    if(hostName.startsWith('localhost')) return true;
    return false;
}